// The following file contains global styles or constants to be used across all pages

// Represents the different sizes of screens
export const breakPoints = {
  tiny: 400,
  small: 600,
  medium: 800,
  large: 1000,
};